import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAPjgDAsEuT7R8V-ZpuJPnx4UjNOon2ZXU",
  authDomain: "work-organiser-mike.firebaseapp.com",
  projectId: "work-organiser-mike",
  storageBucket: "work-organiser-mike.firebasestorage.app",
  messagingSenderId: "109941637243",
  appId: "1:109941637243:web:affac29ab381f839c662de"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
